import {
    getAtomicIdFromNsf,
    getAtomicIdFromSails,
    getSessionStorageItemJson,
    NsfStorage,
    SailsVvlStorage,
} from '@vfde-sails/storage';
import {
    NSF_STORAGE_CURIOSITY_FLOW,
    SAILS_VVL_STORAGE,
} from '@vfde-sails/constants';

const getAtomicId = (): string | null => getAtomicIdFromSailsStorage() ?? getAtomicIdFromNsfStorage();

export default getAtomicId;

const getAtomicIdFromSailsStorage = (): string | null => {
    const storage = getSessionStorageItemJson<SailsVvlStorage>(SAILS_VVL_STORAGE);

    if (!storage) {
        return null;
    }

    const atomicId = getAtomicIdFromSails(storage);

    if (!atomicId) {
        return null;
    }

    return `${atomicId}`;
};

const getAtomicIdFromNsfStorage = (): string | null => {
    const storage = getSessionStorageItemJson<NsfStorage>(NSF_STORAGE_CURIOSITY_FLOW);

    if (!storage) {
        return null;
    }

    const atomicId = getAtomicIdFromNsf(storage);

    if (!atomicId) {
        return null;
    }

    return `${atomicId}`;
};
